import { instance } from "apis/interceptor";
import { TSlackChannel } from "apis/messangers";
import { ResponseType } from "apis/meetings/meeting-reservation";

export interface IAlarmChannel extends TSlackChannel {
  id: string;
  mediumType: string;
  channelProvider: "SLACK";
  isActive: boolean;
}

//INFO: 민원 수신 슬랙 채널 조회
export const getComplainSlackChannel = async (): Promise<ResponseType<IAlarmChannel[]>> => {
  try {
    const result = await instance.get(`/meeting-room-complain/alarm-channel/slack`);

    return { success: true, data: result.data };
  } catch (e) {
    console.error(e);
    return { success: false, message: "민원 수신 채널 정보를 가져오는데 실패했습니다." };
  }
};

//INFO: 민원 수신 슬랙 채널 연동
export const connectComplainSlackChannel = async (slackChannel: TSlackChannel): Promise<ResponseType<boolean>> => {
  try {
    const result = await instance.patch(`/meeting-room-complain/alarm-channel/slack`, slackChannel);

    return { success: result.data.result };
  } catch (e) {
    console.error(e);
    return { success: false, message: "민원 수신 채널 연동에 실패했습니다." };
  }
};

//INFO: 민원 수신 슬랙 채널 해제
export const disconnectComplainSlackChannel = async (meetingRoomComplainId: string): Promise<ResponseType<boolean>> => {
  try {
    const result = await instance.delete(`/meeting-room-complain/alarm-channel/slack`, {
      data: { id: meetingRoomComplainId },
    });

    return { success: result.data.result };
  } catch (e) {
    console.error(e);
    return { success: false, message: "민원 수신 채널 해제에 실패했습니다." };
  }
};
